import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { NotificationService } from './notification.service';
import { NotificationItem, NotificationType } from './notification.models';

/**
 * IsToastContainerComponent
 *
 * Container global de toasts. Coloque uma vez no app.component.html.
 *
 * @example
 * <!-- No app.component.html -->
 * <is-toast-container></is-toast-container>
 */
@Component({
  selector: 'is-toast-container',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="is-toast-container" [class]="'is-toast-container--' + notifyService.position">
      <div
        *ngFor="let item of notifications; trackBy: trackById"
        class="is-toast"
        [class]="'is-toast is-toast--' + item.type"
        role="alert"
        aria-live="assertive"
      >
        <div class="is-toast__icon">
          <i [class]="'bx ' + getIcon(item)"></i>
        </div>
        <div class="is-toast__body">
          <strong *ngIf="item.title" class="is-toast__title">{{ item.title }}</strong>
          <p class="is-toast__message">{{ item.message }}</p>
          <button
            *ngIf="item.action"
            type="button"
            class="is-toast__action"
            (click)="item.action!.callback(); dismiss(item.id)"
          >
            {{ item.action!.label }}
          </button>
        </div>
        <button
          *ngIf="item.dismissible"
          type="button"
          class="is-toast__close"
          (click)="dismiss(item.id)"
          aria-label="Fechar"
        >
          <i class="bx bx-x"></i>
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./toast-container.component.scss'],
})
export class ToastContainerComponent implements OnInit, OnDestroy {
  notifications: NotificationItem[] = [];
  private subscription?: Subscription;

  private readonly iconMap: Record<NotificationType, string> = {
    success: 'bx-check-circle',
    error: 'bx-error-circle',
    warning: 'bx-error',
    info: 'bx-info-circle',
  };

  constructor(public notifyService: NotificationService) {}

  ngOnInit(): void {
    this.subscription = this.notifyService.notifications$.subscribe(
      (items) => (this.notifications = items),
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  getIcon(item: NotificationItem): string {
    return item.icon || this.iconMap[item.type || 'info'];
  }

  dismiss(id: string): void {
    this.notifyService.dismiss(id);
  }

  trackById(_: number, item: NotificationItem): string {
    return item.id;
  }
}
